'use strict';
/* eslint no-console: 0 */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _ = require('_');

var _utils = require('react-utils/utils');

var _validateEventLogAttempt = require('event-tracking-tools/events/validateEventLogAttempt');

var _validateEventLogAttempt2 = _interopRequireDefault(_validateEventLogAttempt);

var _getIsDebugMode = require('event-tracking-tools/utils/getIsDebugMode');

var _getIsDebugMode2 = _interopRequireDefault(_getIsDebugMode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// quick polyfills just in case
if (!console.group) {
  console.group = function () {
    return;
  };
}
if (!console.groupEnd) {
  console.groupEnd = function () {
    return;
  };
}
if (!console.table) {
  console.table = function () {
    return;
  };
}

function BaseEventLoggerException() {
  this.message = 'BaseEventLogger: method \'' + name + '\' is not implemented. Please extend this class and implement this method';
  this.name = 'BaseEventLoggerException';
}

function BaseEventLoggerDirectUseException() {
  this.message = 'BaseEventLogger: do not log directly from BaseEventLogger! Use a pre-made class or extend it.';
  this.name = 'BaseEventLoggerDirectUseException';
}

function BaseEventLoggerNoMatchException(acceptedRecord, eventRecord) {
  this.message = 'BaseEventLogger: log() only accepts events of type(s) ' + acceptedRecord.name + '. Got \'' + eventRecord + '\'';
  this.name = 'BaseEventLoggerNoMatchException';
}

// supports array or single var format
function validateMatchingLogger(acceptedRecord, eventRecord) {
  var hasMatch = void 0;

  if ((0, _.isArray)(acceptedRecord)) {
    hasMatch = (0, _.some)(acceptedRecord, function (recordClass) {
      return eventRecord instanceof recordClass;
    });
  } else {
    hasMatch = eventRecord instanceof acceptedRecord;
  }

  if (!hasMatch) {
    throw new BaseEventLoggerNoMatchException(acceptedRecord, eventRecord);
  }
}

var BaseEventLogger = function () {
  function BaseEventLogger() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, BaseEventLogger);

    var _opts$useStrict = opts.useStrict,
        useStrict = _opts$useStrict === undefined ? true : _opts$useStrict;

    this.acceptedRecord = null;
    this.useStrict = useStrict;
  }

  _createClass(BaseEventLogger, [{
    key: 'transform',
    value: function transform() {
      throw new BaseEventLoggerException('transform');
    }
  }, {
    key: 'send',
    value: function send() {
      throw new BaseEventLoggerException('send');
    }
  }, {
    key: 'log',
    value: function log(eventRecord) {
      var _this = this;

      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.acceptedRecord) {
        throw new BaseEventLoggerDirectUseException();
      }

      validateMatchingLogger(this.acceptedRecord, eventRecord);

      (0, _validateEventLogAttempt2.default)(eventRecord, props, this.useStrict);

      var payload = this.transform(eventRecord, _extends({}, props));

      (0, _utils.invariant)(payload !== null && payload !== undefined, 'event-tracking-tools: [BaseEventLogger] transform() must return a value. Got "%s"', payload);

      if ((0, _getIsDebugMode2.default)()) {
        var group = '[' + this.constructor.name + '] ' + (eventRecord.name || 'Event');
        // Note - `group`, `groupEnd`, and `table` are not widely supported yet!
        //        Be sure you have polyfills available if you use them.
        console.group(group);
        console.table([payload]);
        console.groupEnd(group);
      }

      // Only defer sending of event if app is deployed to avoid breaking local unit tests.
      if (_enviro2.default.deployed() && window.hasOwnProperty('requestIdleCallback')) {
        window.requestIdleCallback(function () {
          _this.send(payload);
        });
        return null;
      }

      return this.send(payload);
    }
  }]);

  return BaseEventLogger;
}();

exports.default = BaseEventLogger;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/event-tracking-tools/static-1.15/js/loggers/BaseEventLogger.js
// module id = 433
// module chunks = 0